/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancelling_EstesInputs */

const en_orders_cancelling_estes = /** @type {(inputs: Orders_Cancelling_EstesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelling ESTES...`)
};

const es_orders_cancelling_estes = /** @type {(inputs: Orders_Cancelling_EstesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelando ESTES...`)
};

/**
* | output |
* | --- |
* | "Cancelling ESTES..." |
*
* @param {Orders_Cancelling_EstesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancelling_estes = /** @type {((inputs?: Orders_Cancelling_EstesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancelling_EstesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancelling_estes(inputs)
	return es_orders_cancelling_estes(inputs)
});